import styled from 'styled-components'

export const HydraTableContainer = styled.div`
    position: relative;
`

export const Loading = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 2;
    pointer-events: none;
    transition: background-color 0.2s ease-in;
    padding-top: 20vh;

    &.nestedTable {
        padding-top: 0;
    }

    &.loading {
        pointer-events: all;
        background-color: ${props => props.theme.admin.colors.background};
        &.nestedTable {
            background-color: #fff;
        }
    }
`
